import React from 'react';
import { Link } from 'react-router-dom';
import NotFoundMessage from '#component/general/not-found-message';
import PreloaderComponent from '#component/preloader';
import {
  Container,
  MarginTopThree,
  CallToActionButton
} from '#component/warehouse/site-manager/styles';
import { CardsContainer } from '#component/warehouse/cards-view/styles';
import ApplianceCard from './card';

const CardView = props => {
  const {
    appliances,
    loading,
    status,
    account,
    showAllId,
    applianceDevices,
    setShowAllId,
    handleApplianceClick,
    warehouses,
    noData
  } = props;
  const { userType } = account;

  if (noData) {
    return (
      <Container>
        <CardsContainer>
          {!appliances.length && userType < 10 && <MarginTopThree />}
          {userType < 10 ?
            (warehouses.length ?
              <CallToActionButton
                variant="contained"
                color="secondary"
                component={Link}
                to="/warehouse/appliance/create"
              >
                Create application
              </CallToActionButton> :
              <CallToActionButton
                variant="contained"
                color="secondary"
                component={Link}
                to="/create-warehouse"
              >
                Create site
              </CallToActionButton>) :
              <NotFoundMessage>
                All your applications will appear here soon
              </NotFoundMessage>}
        </CardsContainer>
      </Container>);
  }

  if (!appliances.length && loading) {
    return (
      <Container>
        <CardsContainer>
          <PreloaderComponent />
        </CardsContainer>
      </Container>
    );
  }

  if (!appliances.length && !loading) {
    return (
      <NotFoundMessage>
        No application found
      </NotFoundMessage>
    );
  }
  return (
    <Container>
      <CardsContainer isLoading={loading}>
        {!appliances.length && userType < 10 && <MarginTopThree />}
        {appliances.map(a => (
          <ApplianceCard
            key={a.id}
            appliance={a}
            status={status}
            account={account}
            showAllId={showAllId}
            applianceDevices={applianceDevices ?? []}
            setShowAllId={setShowAllId}
            onClick={handleApplianceClick(a)}
          />
        ))}
      </CardsContainer>
    </Container>
  );
};

export default CardView;
